import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DateTime } from 'luxon';
import { LdsUserService } from './lds-user.service';

@Injectable({
  providedIn: 'root'
})
export class OctopusService {

  periodTo: string;
  periodFrom: string;

  constructor(private http: HttpClient, private user: LdsUserService) {
  }

  getOctopusUserData() {
    return this.user.getOctopusData();
  }

  getOctopusData = (timespan) => {
    const { serialNumber, mpan, apiKey } = this.getOctopusUserData();
    this.getTimes(timespan);
    const options = {
      headers: new HttpHeaders({
        "Authorization": `Basic ${apiKey}`
      })
    }
    return this.http.get(`https://api.octopus.energy/v1/electricity-meter-points/${mpan}/meters/${serialNumber}/consumption/?group_by=day&period_to=${this.periodTo}&period_from=${this.periodFrom}&page_size=25000`, options);
  }

  getOctopusPowerData = (timespan) => {
    const { serialNumber, mpan, apiKey } = this.getOctopusUserData();
    this.getTimes(timespan)
    const options = {
      headers: new HttpHeaders({
        "Authorization": `Basic ${apiKey}`
      })
    }
    return this.http.get(`https://api.octopus.energy/v1/electricity-meter-points/${mpan}/meters/${serialNumber}/consumption/?group_by=hour&period_to=${this.periodTo}&period_from=${this.periodFrom}&page_size=25000`, options);
  }

  getTimes(timespan) {
    const timespanNumber = timespan === 'monthly' ? 30 : 7;
    const toDateTime = DateTime.now().startOf('day')
    const fromDateTime = DateTime.now().startOf('day').minus({days: timespanNumber});
    const toDateTimeDate = toDateTime.toFormat('yyyy-MM-dd');
    const toDateTimeTime = toDateTime.toFormat('T');
    const fromDateTimeDate = fromDateTime.toFormat('yyyy-MM-dd');
    const fromDateTimeTime = fromDateTime.toFormat('T');
    this.periodTo = `${toDateTimeDate}T${toDateTimeTime}Z`
    this.periodFrom = `${fromDateTimeDate}T${fromDateTimeTime}Z`
  }
}
